import PasswordConfirmation from './PasswordConfirmation'

export default PasswordConfirmation
